import { DateTime } from "luxon";
import { Just, Maybe, Nothing } from "purify-ts";

const valid = (date: DateTime): Maybe<DateTime> => {
  return date.isValid ? Just(date) : Nothing;
};

export const toValidLuxonDateTimeFromEventDate = (
  providedDate: string,
  providedTimezone: string,
): Maybe<DateTime> => {
  return valid(DateTime.fromISO(providedDate, { zone: providedTimezone }));
};

export const toValidLuxonDateTimeFromEventDateAndTime = (
  providedDate: string,
  providedTime: string,
  providedTimezone: string,
): Maybe<DateTime> => {
  return valid(
    DateTime.fromISO(`${providedDate}T${providedTime}`, {
      zone: providedTimezone,
    }),
  );
};
